import { Avatar, Typography } from "@mui/material";
import { classes } from "portal/theme/theme";
import { DisplayUser } from "protos/portal/category_profile";
import { getInitials } from "portal/utils/user";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import CarbonLogo from "portal/images/logo_icon.svg?react";
import React, { FC } from "react";

interface VersionUserProps {
  user?: DisplayUser | undefined;
  className?: string;
}

const UnknownVersionUser: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      className={classes("text-xs", className)}
    >
      {t("utils.descriptors.unknown")}
    </Typography>
  );
};

export const VersionUser: FC<VersionUserProps> = ({ user, className }) => {
  const { t } = useTranslation();
  const { isInternal: isSelfInternal } = useSelf();

  if (!user) {
    return <UnknownVersionUser className={className} />;
  }

  const { displayName: backendDisplayName, picture, isInternal } = user;
  const showCarbonSupport = isInternal && !isSelfInternal;
  let userName = showCarbonSupport
    ? t("views.fleet.robots.support.carbon")
    : backendDisplayName;
  if (["legacy-api", "import"].includes(backendDisplayName)) {
    userName = t("utils.descriptors.unknown");
  }

  const avatarClasses = "w-4 h-4 shrink-0 text-[10px]";
  return (
    <div className={classes("flex min-w-0 items-center gap-2", className)}>
      {showCarbonSupport ? (
        <Avatar
          alt={userName}
          className={classes(avatarClasses, "bg-carbon-orange")}
        >
          <CarbonLogo className="w-2.5 h-2.5 text-white" />
        </Avatar>
      ) : (
        <Avatar src={picture} alt={userName} className={avatarClasses}>
          {getInitials(userName)}
        </Avatar>
      )}
      <Typography
        variant="body2"
        color="textSecondary"
        className="min-w-0 text-xs overflow-ellipsis whitespace-nowrap overflow-hidden"
      >
        {userName}
      </Typography>
    </div>
  );
};
